import { DashboardCardType } from 'themes/types';
import { SYSTEM_COLORS } from '../system-colors';

export const DASHBOARD_CARD_TYPE: DashboardCardType = {
  dashboardCardType: {
    default: SYSTEM_COLORS.neutral_200,
    WAITING_ATTENDANCE: SYSTEM_COLORS.warning_300,
    RETURN_REQUEST_IN_PROGRESS: SYSTEM_COLORS.success_200,
    WAITING_CUSTOMER_PICK_UP: SYSTEM_COLORS.success_300,
    DELIVERY_FAILURE: SYSTEM_COLORS.danger_300,
    ON_CARRIAGE: SYSTEM_COLORS.success_200,
    DELIVERY_FAILED_QUESTION: SYSTEM_COLORS.danger_300,
  },
};
